var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex min-h-screen max-h-screen flex-col"},[_c('div',{staticClass:"flex mx-auto p-4 w-full justify-center"},[_c('p',[_vm._v(_vm._s(_vm.$t("index.navigate")))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }